export interface HonoredMemberOption {
  "@id": string;
  firstName: string;
  lastName: string;
}

// Ajoute le président aux options "membres à l'honneur" (absent de attendedMembers), dédup par @id.
export const mergePresidentIntoHonoredOptions = <T extends HonoredMemberOption>(
  attendedMembers: T[] | undefined,
  president: T | null | undefined,
): T[] => {
  const members = attendedMembers ?? [];

  if (!president) {
    return members;
  }

  if (members.some((member) => member["@id"] === president["@id"])) {
    return members;
  }

  return [...members, president];
};
